<div class="route-list">
  <h2>Select a Route</h2>
  <app-search-bar [placeholder]="'Search Routes'"
                  (search)="searchTerm = $event; searchRoutes()">
  </app-search-bar>

  <div class="route-card" *ngFor="let route of filteredRoutes" (click)="selectRoute(route)">
    <mat-icon>map</mat-icon>
    {{ route.route }}
  </div>
</div>
